




































import {Component, Mixins} from "vue-property-decorator";
import EmployeeMixin from "@/mixins/employee";
import {faGenderless, faGlasses, faLockOpen} from "@fortawesome/free-solid-svg-icons";

@Component({
    components: {

    }
})
export default class Home extends Mixins(EmployeeMixin) {
    private icons = {
        faGenderless,
        faGlasses,
        faLockOpen,
    }

    private async mounted() {
        if (!await this.authorized()) {
            this.$router.push({name: "Login"});
        }
    }

    async logout() {
        await this.deauthorize();
        await this.$router.push({name: "Login"});
    }

}
